import SoftAlert from './SoftAlert';
import { Alert } from './types';
import css from './AlertContainer.module.css';

interface Props {
  alerts: Alert[];
  onHideAlert: (id: number) => void;
}

export function AlertContainer({ alerts, onHideAlert }: Props) {
  return (
    <div className={css.container}>
      {alerts.map(alert => (
        <SoftAlert
          key={alert.id}
          content={alert.message}
          type={alert.type}
          hideTimeout={alert.duration}
          onClose={() => onHideAlert(alert.id)}
        />
      ))}
    </div>
  );
}
